import { Modal, Row, Col, Button, Affix, Typography } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import OptionImage from '../image/OptionImage';
import { useBaseAdminModal } from '../controller/BaseAdminModalController';
import axios from 'axios';
const BaseAdminModal = ({
    type = "option",
    title = "新增資料",
    only_cancle = false,
    open = true,
    confirmLoading = false,
    onOk = () => { },
    onCancel = () => { },
    width = 520,
    showImage = true,
    ...props
}) => {

    const {
        imageSrc,
        okButtonBackgroundColor,
        okButtonColor,
        cancelButtonBackgroundColor,
        cancelButtonColor,
        ModalBackgroundColor,
        ModalBorderTop,

    } = useBaseAdminModal({ type })
    return (
        <>
            <Modal
                open={open}
                onOk={onOk}
                onCancel={onCancel}
                confirmLoading={confirmLoading}
                maskClosable={false}
                width={width ?? 520}
                modalRender={(e) => <>
                    <div
                        style={{
                            pointerEvents: 'auto',//這很重要
                            backgroundColor: ModalBackgroundColor,
                            borderTop: `solid ${ModalBorderTop} 5px `,
                            padding: '20px',
                            position: 'relative',
                            height: '90vh',
                            align: "space-between"
                        }}>
                        <Row gutter={[10, 10]}>
                            <Col span={24}>
                                <Row
                                    gutter={[10, 10]} justify='center'
                                    style={{
                                        minHeight: '65vh',
                                        maxHeight: '80vh',
                                        overflowY: 'scroll'
                                    }}>
                                    <Col span={24} >
                                        <Row gutter={[8, 8]} align={'middle'}>
                                            {showImage &&
                                                (<Col showImage span={9}>
                                                    <Row
                                                        justify={"center"}
                                                        align={"middle"}
                                                        style={{
                                                            backgroundImage: `url(${imageSrc})`,
                                                            width: "10rem",
                                                            height: "10rem",
                                                            backgroundRepeat: "no-repeat",
                                                            backgroundSize: '100%',
                                                        }}
                                                    >
                                                        <Col span={14}>
                                                            <Row justify={"center"}>
                                                                <Col>
                                                                    <Typography.Title
                                                                        style={{
                                                                            whiteSpace: 'break-spaces'
                                                                        }}
                                                                        level={4}>
                                                                        {title}
                                                                    </Typography.Title>
                                                                </Col>
                                                            </Row>

                                                        </Col>
                                                    </Row>
                                                </Col>)}
                                            <Col span={24}>
                                                {props.children}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row >
                                    <Col span={24}>
                                        <Affix offsetBottom={5}>
                                            <Row gutter={[10, 10]} align="bottom" justify={"center"}>
                                                <Col>
                                                    <Button
                                                        size='large'
                                                        style={{
                                                            background: cancelButtonBackgroundColor,
                                                            color: cancelButtonColor
                                                        }}
                                                        onClick={(e) => {
                                                            onCancel()
                                                        }}
                                                        block
                                                    >
                                                        {only_cancle ? "關閉" : "取消"}
                                                    </Button>

                                                </Col>
                                                {!only_cancle &&
                                                    <Col >
                                                        <Button
                                                            onClick={e => { onOk() }}
                                                            size='large'
                                                            style={{
                                                                background: okButtonBackgroundColor,
                                                                color: okButtonColor
                                                            }}
                                                            block
                                                        >
                                                            {props.edit ? '修改' : '送出'}
                                                        </Button>
                                                    </Col>
                                                }
                                            </Row>
                                        </Affix>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div >
                </>}
                centered
            >
            </Modal >
        </>
    )

}

export default BaseAdminModal;
